{
  "id": 34,
  "location": "paris",
  "difficulty": "normal",
  "moves": 25,
  "kinds": 6,
  "goals": [
    { "type": "mud" },
    { "type": "collect", "kind": "donut", "count": 32 },
    { "type": "collect", "kind": "latte", "count": 32 }
  ],
  "stars": [4090, 4940],
  "board": [
    "# # . . . . # #",
    "# . . . . . . #",
    ". . . . . . . .",
    ". . . X X . . .",
    ". . . X X . . .",
    ". . . . . . . .",
    "# . . . . . . #",
    "# # . . . . # #"
  ],
  "calibration": { "runs": 1000, "winRate": 0.713, "movesLeft": 4.7, "closeLosses": 0.114, "target": 0.68 }
}
